/* eslint-disable @typescript-eslint/no-explicit-any */
import { first, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { CheckoutState, checkoutQuery, fromCheckoutActions } from '../+state';

@Injectable()
export class CardResolver {
  constructor(private _store: Store<CheckoutState>) {}

  /*
   * Resolve Card
   * 1. Selects Cards from the store
   * 2. Checks Cards are present
   *    -If they don't exist:
   *    1. GetCards
   */
  public resolve(): Observable<any> {
    return this._store.select(checkoutQuery.getCards).pipe(
      switchMap(() => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getCards();
        return of(true);

        // if (!cards) {
        //   this.getCards();
        // }

        // return of(cards);
      }),
      first()
    );
  }

  /*
   * trigger fetching cards
   * 1. Dispatch getCards action
   * 2. Listening to setCards
   * 3. Return payload of setCards
   */
  private getCards() {
    this._store.dispatch(fromCheckoutActions.getCards());
  }
}
